import { AssetType } from "@zapier/canvas-state";

export interface IframeConfig {
  elementsToHide: string[];
  customCSS: string;
}

// Asset-specific configurations
const ASSET_IFRAME_CONFIGS: Record<string, IframeConfig> = {
  zap: {
    elementsToHide: [
      "header", // Hide header
      "aside", // Hide sidebar
      "article", // Hide any possible banners
      'button[aria-label="Copy step"]', // Hide copy step button
      "[data-testid*='copilot']", // Hide copilot
    ],
    customCSS: `
      body > div:first-child > div:nth-child(3) {
        max-height: 100vh;
        min-height: 100vh;
        grid-template:
          "left-sidebar topnav" 0
          "left-sidebar editor" 1fr / 0 1fr;
      }
    `,
  },
};

/**
 * Get iframe manipulation configuration for a specific asset type
 */
export function getIframeConfig(assetType: AssetType): IframeConfig | null {
  if (!assetType) {
    return null;
  }
  return ASSET_IFRAME_CONFIGS[assetType] || null;
}

/**
 * Inject CSS and hide elements in an iframe based on asset type
 */
export function hideElementsInIframe(
  iframe: HTMLIFrameElement,
  assetType: AssetType,
): void {
  if (!assetType) return;

  const config = getIframeConfig(assetType);
  if (!config) return;

  try {
    const iframeDocument = iframe.contentDocument;
    if (!iframeDocument) return;

    // Build CSS to inject
    const hideCSS = config.elementsToHide
      .map((selector) => `${selector} { display: none !important; }`)
      .join("\n");

    const allCSS = hideCSS + "\n" + config.customCSS;

    if (allCSS.trim()) {
      const style = iframeDocument.createElement("style");
      style.textContent = allCSS;
      iframeDocument.head.appendChild(style);
    }
  } catch (error) {
    console.error(`Failed to hide elements in iframe for ${assetType}:`, error);
  }
}
